import { render, staticRenderFns } from "./SkupStavke.vue?vue&type=template&id=d5d8c4d2&scoped=true&"
import script from "./SkupStavke.vue?vue&type=script&lang=js&"
export * from "./SkupStavke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d8c4d2",
  null
  
)

export default component.exports